// SubjectView.jsx
import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { cardsAPI } from '../../services/api';

export default function SubjectView() {
  const { subjectName } = useParams();
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [examType, setExamType] = useState('');
  const [expanded, setExpanded] = useState(null);

  useEffect(() => {
    setLoading(true);
    cardsAPI.getAll({ subject: subjectName, examType: examType || undefined, limit: 50 })
      .then(res => setCards(res.data.cards))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [subjectName, examType]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }} className="fade-in">
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
        <Link to="/browse" style={{ color: 'var(--text-3)', textDecoration: 'none', fontSize: '0.875rem' }}>← Browse</Link>
        <h1 className="page-title">{subjectName}</h1>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '0.5rem' }}>
          {['', 'Prelims', 'Mains'].map(t => (
            <button key={t} className={`btn ${examType === t ? 'btn-primary' : 'btn-secondary'} btn-sm`}
              onClick={() => setExamType(t)}>
              {t || 'All'}
            </button>
          ))}
          <Link to="/study" className="btn btn-primary btn-sm" state={{ subject: subjectName }}>Study →</Link>
        </div>
      </div>

      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {[...Array(5)].map((_, i) => <div key={i} className="skeleton" style={{ height: 70, borderRadius: 12 }} />)}
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {cards.map(card => (
            <div key={card._id}
              style={{
                background: 'var(--bg-card)', border: `1px solid ${expanded === card._id ? 'var(--saffron)' : 'var(--border)'}`,
                borderRadius: 12, overflow: 'hidden', cursor: 'pointer', transition: 'border-color 0.2s'
              }}
              onClick={() => setExpanded(expanded === card._id ? null : card._id)}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', padding: '0.875rem 1rem' }}>
                <div style={{ flex: 1, fontSize: '0.9rem', lineHeight: 1.4 }}>{card.question}</div>
                <div style={{ display: 'flex', gap: '0.35rem', flexShrink: 0 }}>
                  <span className={`badge ${card.examType === 'Prelims' ? 'badge-saffron' : card.examType === 'Mains' ? 'badge-blue' : 'badge-purple'}`}>{card.examType}</span>
                  <span className={`badge ${card.difficulty === 'Easy' ? 'badge-green' : card.difficulty === 'Hard' ? 'badge-red' : 'badge-gold'}`}>{card.difficulty}</span>
                </div>
              </div>
              {expanded === card._id && (
                <div style={{ padding: '0.75rem 1rem 1rem', borderTop: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: '0.6rem' }} className="slide-up">
                  <div style={{ fontSize: '0.7rem', textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--text-3)' }}>Answer</div>
                  <div style={{ fontSize: '0.9rem', lineHeight: 1.55 }}>{card.answer}</div>
                  {card.explanation && <div style={{ fontSize: '0.85rem', color: 'var(--text-2)', background: 'var(--bg-3)', borderRadius: 8, padding: '0.65rem' }}>{card.explanation}</div>}
                </div>
              )}
            </div>
          ))}
          {cards.length === 0 && <div style={{ textAlign: 'center', color: 'var(--text-2)', padding: '3rem' }}>No cards found.</div>}
        </div>
      )}
    </div>
  );
}
